import * as React from 'react';

import PageWrapper from '~/common/layout/PageWrapper';

import Demo from '../components/app/Demo';


export default function(params) {
  return (
    <React.Fragment>
      <PageWrapper>
        <Demo />
      </PageWrapper>
    </React.Fragment>
  );
};
